import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from '../../core/components/Loading';
import { saveTwitterAuth } from '../../core/services/twitter';

export function TwitterCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthToken = params.get('oauth_token');
    const oauthVerifier = params.get('oauth_verifier');

    if (!oauthVerifier) {
      navigate('/dashboard', { replace: true });
      return;
    }

    saveTwitterAuth(oauthToken, oauthVerifier)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((err) => {
        console.error('Twitter auth save failed:', err);
        setError('Twitter連携に失敗しました');
      });
  }, [navigate]);

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <p>{error}</p>
        <button onClick={() => navigate('/dashboard')}>ダッシュボードに戻る</button>
      </div>
    );
  }

  return <Loading fullScreen />;
}
